var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risks"},[_c('query-builder',{key:_vm.refreshKey,attrs:{"cubejs-api":_vm.cubejsApi,"query":_vm.query},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var resultSet = ref.resultSet;
return [(!loading && resultSet)?_c('chart-adapter',{attrs:{"type":"line","companyName":_vm.companyName,"yjz":_vm.yjz,"result-set":resultSet,"height":"369"}}):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }